import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { Injectable } from '@angular/core';
import { ProviderServiceOptionModel } from "../providerServiceOption.model";
import { ProviderServiceOptionSummaryConverter } from "./providerServiceOptionSummary.converter";
import {ProductSummaryConverter} from "../../../../../../product/api/entity/converter/productSummary.converter";
import {ProviderServiceSummaryConverter} from "../../../../api/entity/converter/providerServiceSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceOptionConverter extends HttpModelConverter<ProviderServiceOptionModel> {

    constructor(private summaryConverter: ProviderServiceOptionSummaryConverter,
                private productSummaryConverter: ProductSummaryConverter,
                private providerServiceSummaryConverter: ProviderServiceSummaryConverter) {
        super();
    }

    protected createInstance(): ProviderServiceOptionModel {
        return new ProviderServiceOptionModel();
    }

    protected enrichObject(result: ProviderServiceOptionModel, src: ProviderServiceOptionModel): void {
        result.summary = this.summaryConverter.convert(src.summary);
        result.product = this.productSummaryConverter.convert(src.product);
        result.providerService = this.providerServiceSummaryConverter.convert(src.providerService);
    }
}

